module.exports = __webpack_public_path__ + "img/lg_ring_g_o_1_null@3x.18da8cc6.png";